import { useMutation } from '@tanstack/react-query';
import { putForgotPassword } from '../../apis';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleErrorResponse } from '../../utils/handleError';
import { triggerSnackbar } from '../../provider/SnackbarProvider';

export function useForgotPassword(isProfile?: boolean) {
  const navigate = useNavigate();
  const [disableSubmit, setDisableSubmit] = useState(false);

  const { mutate, isPending, status } = useMutation({
    mutationKey: ['patient-forgot-password'],
    mutationFn: putForgotPassword,
    onSuccess: (data) => {
      if (!isProfile) {
        const message = data?.message || '';
        triggerSnackbar({
          message: message,
          severity: 'success',
        });
        navigate('/login');
      }
    },
    onError: (error) => handleErrorResponse(error, 'Forgot password'),
    onSettled: () => setDisableSubmit(false),
  });

  const sendForgotPasswordRequest = (email: string) => {
    setDisableSubmit(true);
    mutate(email);
  };

  return {
    sendForgotPasswordRequest,
    disableSubmit: isPending || disableSubmit,
    isPending,
    status,
  };
}
